import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AutomotiveAftermarketProfileModel } from '../models';
import { AutomotiveAftermarketProfileEndpoint } from '../constants/automotive-aftermarket-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileItemService {
  constructor(private http: WrapperHttpService) {}

  getAutomotiveAftermarketProfile(id: number): Observable<AutomotiveAftermarketProfileModel> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<AutomotiveAftermarketProfileModel>(url);
  }

  createAutomotiveAftermarketProfile(
    body: Partial<AutomotiveAftermarketProfileModel>,
  ): Observable<AutomotiveAftermarketProfileModel> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<AutomotiveAftermarketProfileModel>(url, body);
  }

  updateAutomotiveAftermarketProfile(
    body: Partial<AutomotiveAftermarketProfileModel>,
  ): Observable<AutomotiveAftermarketProfileModel> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<AutomotiveAftermarketProfileModel>(url, body);
  }
}
